import React from 'react';
import { Col } from 'react-bootstrap';
import ReactStars from 'react-rating-stars-component';

const ReviewsList = props => {
  const itemData = props.data;

  const ReviewItem = props => {
    const { field_first_name, field_star_rating, comment_body } =
      props.data.attributes;
    return (
      <Col className="col-12 review-item">
        <span className="fw-800">
          {field_first_name && <Col>Reviewed by: {field_first_name}</Col>}
        </span>
        <Col className="col-12 col-nd-6">
          <ReactStars
            classNames="rating"
            count={field_star_rating}
            size={24}
            activeColor="#3F2B56"
            onChange={null}
            edit={false}
          />
        </Col>
        <Col className="w-100">
          <p dangerouslySetInnerHTML={{__html: comment_body.value}} />
        </Col>
      </Col>
    );
  };

  if (itemData) {
    return (
      <>
        {itemData.map(item => (
          <ReviewItem data={item} />
        ))}
      </>
    );
  } else {
    return <>Null</>;
  }
};

export default ReviewsList;
